import { formatNumber } from './formatNumber';
import { NBSP } from '../../constants/symbols';

export const formatAmount = (count: number): string => {
  return `${formatNumber(count)}${NBSP}шт.`;
};
